// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Auth_wrapper__EzhVB","container":"Auth_container__2TsfH","content":"Auth_content__3ojsn","info":"Auth_info__2fjak","blue":"Auth_blue__1kgbL"};